var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "loading", class: { "is-retry": _vm.showRetry } },
    [
      _vm.showRetry
        ? _c("div", { staticClass: "loading__retry" }, [
            _c("p", { staticClass: "loading__message" }, [
              _vm._v(
                _vm._s(_vm.$t("assistantCatHome.connectionError.message"))
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "loading__retry-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t(
                    "assistantCatHome.connectionError.retry"
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("retry")
                  },
                },
              },
              [_c("icon-refresh")],
              1
            ),
            _c("p", { staticClass: "loading__retry-label" }, [
              _vm._v(_vm._s(_vm.$t("assistantCatHome.connectionError.retry"))),
            ]),
          ])
        : _c("div", { staticClass: "loading__idle" }, [
            _c("p", { staticClass: "loading__text" }, [
              _vm._v(_vm._s(_vm.$t("assistantCatHome.loading"))),
            ]),
            _c(
              "div",
              {
                staticClass: "loading__paws",
                attrs: { "aria-hidden": "true" },
              },
              [
                _vm.pawCount >= 1
                  ? _c("icon-assist", {
                      staticClass: "loading__paw loading__paw--1",
                    })
                  : _vm._e(),
                _vm.pawCount >= 2
                  ? _c("icon-assist", {
                      staticClass: "loading__paw loading__paw--2",
                    })
                  : _vm._e(),
                _vm.pawCount >= 3
                  ? _c("icon-assist", {
                      staticClass: "loading__paw loading__paw--3",
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }